import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import DerechosPage from "@/pages/derechos/page";
import NosotrosPage from "@/pages/nosotros/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/derechos",
    element: <DerechosPage />,
  },
  {
    path: "/nosotros",
    element: <NosotrosPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;